module.exports = __webpack_public_path__ + "img/GoFoBananas@2x.073a154b.png";